import { THAI_MONTHS_SHORT } from "../config/constants";

export const getCurrentDateTimeLocal = (dateObj) => {
  const d = dateObj || new Date();
  const pad = (num) => String(num).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
};

export const parseDateSafe = (dateStr) => {
  if (!dateStr) return null;
  const str = String(dateStr).trim();

  // 🔴 1. ดักจับรูปแบบ DD/MM/YYYY หรือ DD-MM-YYYY จาก Google Sheets เป็นอันดับแรก
  // (เพื่อป้องกัน JS สลับเดือนกับวันแบบอเมริกัน)
  const matches = str.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})/);
  if (matches) {
    const day = parseInt(matches[1], 10);
    const month = parseInt(matches[2], 10) - 1; // ใน JS เดือนเริ่มที่ 0
    let year = parseInt(matches[3], 10);

    // ถ้าใส่มาเป็น พ.ศ. ให้แปลงเป็น ค.ศ.
    if (year > 2400) year -= 543;

    // เช็คว่ามีเวลาพ่วงมาด้วยไหม (เช่น 14:30:00)
    const timeMatch = str.match(/(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?/);
    if (timeMatch) {
      return new Date(
        year,
        month,
        day,
        parseInt(timeMatch[1], 10),
        parseInt(timeMatch[2], 10)
      );
    }
    return new Date(year, month, day);
  }

  // 🟢 2. ถ้าเป็นรูปแบบสากล (YYYY-MM-DD...) ให้ใช้ new Date ตามปกติได้เลย
  let d = new Date(str);
  if (!isNaN(d.getTime())) return d;

  return null;
};

export const formatThaiDate = (dateStr) => {
  const d = parseDateSafe(dateStr);
  if (!d) return "-";
  return `${d.getDate()} ${THAI_MONTHS_SHORT[d.getMonth()]} ${
    d.getFullYear() + 543
  }`;
};

export const formatTime = (dStr) => {
  const D = parseDateSafe(dStr); // ใช้ฟังก์ชันแก้บั๊กด้านบนมาช่วยจัดฟอร์แมต
  if (!D) return "-";
  return `${D.getDate()}/${D.getMonth() + 1}/${D.getFullYear()} ${String(
    D.getHours()
  ).padStart(2, "0")}:${String(D.getMinutes()).padStart(2, "0")}`;
};

//aaaaa
